export interface Service {
  slug: string;
  title: string;
  summary: string;
  what: string;
  who: string;
  includes: string[];
}
export const services: Service[] = [{
  slug: 'investment-advisory',
  title: 'Investment advisory & portfolio management',
  summary: 'Model portfolios built by our central research desk, implemented and monitored by your local adviser.',
  what: 'A written investment policy for your family, mapped to model portfolios across equity, debt, gold and select private-market assets. Every instrument is drawn from an approved shelf that has cleared written due diligence at our Bengaluru desk.',
  who: 'Families with ₹5 crore and above in investable assets who want one coherent portfolio instead of a dozen unconnected products.',
  includes: ['Family investment policy statement', 'Asset allocation and rebalancing calendar', 'Manager and fund due diligence notes', 'Consolidated performance reporting across entities']
}, {
  slug: 'estate-succession',
  title: 'Estate & succession planning',
  summary: 'Wills, trusts and succession structures documented before they are needed, not after.',
  what: 'We map ownership across the family, identify where succession would stall, and work with your legal counsel to put wills, private trusts and nomination hygiene in place.',
  who: 'Promoter families, second-generation business owners, and families holding assets across multiple cities or countries.',
  includes: ['Family and asset ownership map', 'Will drafting coordination with counsel', 'Private trust structuring review', 'Nominee and beneficiary audit']
}, {
  slug: 'tax-structuring',
  title: 'Tax & structuring',
  summary: 'Entity and holding structures reviewed so returns are not quietly eroded by avoidable tax.',
  what: 'Post-tax thinking applied to every recommendation: holding entity choice, capital gains sequencing, family arrangement review and repatriation planning for NRI members.',
  who: 'Families with business income, multiple entities, or members resident outside India.',
  includes: ['Annual post-tax portfolio review', 'Holding structure recommendations', 'Capital gains harvesting calendar', 'Coordination with your chartered accountant']
}, {
  slug: 'insurance-risk',
  title: 'Insurance & risk planning',
  summary: "Cover sized to the liability it protects - never sold as an investment.",
  what: 'We quantify the actual risk to the family balance sheet, then recommend the least expensive cover that closes the gap. We earn nothing on what you buy.',
  who: 'Families with business guarantees, key-man dependency, or dependents whose lifestyle relies on a single earner.',
  includes: ['Risk and liability quantification', 'Term, health and liability cover review', 'Existing policy audit and rationalisation', 'Claim assistance for the family']
}, {
  slug: 'family-governance',
  title: 'Family governance & next-gen education',
  summary: 'The conversations and structures that keep wealth intact into the third generation.',
  what: 'Facilitated family meetings, a written family charter, and a structured curriculum that prepares the next generation to be informed owners of capital.',
  who: 'Families preparing for a generational handover, or those where the next generation lives away from the family business.',
  includes: ['Facilitated annual family meeting', 'Family charter and decision rights', 'Next-gen financial literacy programme', 'Philanthropy and giving structure']
}];